import { routePaths } from "../constants/routes";

export { routePaths };

export const relatedCore = [
  { title: "Manual Testing Guide", path: routePaths.manualTesting, category: "Beginner QA" },
  { title: "Automation Testing Guide", path: routePaths.automationTestingTopic, category: "Automation" },
  { title: "API Testing Guide", path: routePaths.apiTesting, category: "API Testing" },
  { title: "Software Testing Guide", path: routePaths.softwareTesting, category: "QA Foundation" },
  { title: "Testing Interview Questions", path: routePaths.interviewQuestions, category: "Interview Prep" },
  { title: "Study Notes", path: routePaths.studyNotes, category: "Revision" },
];

export const topicNavigation = [
  {
    group: "Core QA",
    items: [
      { label: "Software Testing", to: routePaths.softwareTesting },
      { label: "Manual Testing", to: routePaths.manualTesting },
      { label: "What is Manual Testing", to: "/what-is-manual-testing" },
      { label: "Manual Testing Process", to: "/manual-testing-process" },
      { label: "Manual Testing Examples", to: "/manual-testing-examples" },
      { label: "Login Test Case Example", to: "/test-case-example-login" },
      { label: "Bug Report Example", to: "/bug-report-example" },
      { label: "Real-Time Testing Scenarios", to: "/real-time-testing-scenarios" },
      { label: "Manual Testing Interview Questions", to: "/manual-testing-interview-questions" },
      { label: "Manual Tester Skills", to: "/manual-testing-essential-skills" },
      { label: "Automation Testing", to: routePaths.automationTestingTopic },
      { label: "API Testing", to: routePaths.apiTesting },
      { label: "API Testing Tutorial", to: "/api-testing-tutorial" },
      { label: "Postman Tutorial", to: "/postman-tutorial" },
      { label: "REST API Testing", to: "/rest-api-testing" },
      { label: "API Status Codes", to: "/api-status-codes" },
      { label: "API Test Cases", to: "/api-test-cases" },
      { label: "Study Notes", to: routePaths.studyNotes },
      { label: "Interview Questions", to: routePaths.interviewQuestions },
      { label: "QA Fresher Interview Questions", to: "/qa-interview-questions-fresher" },
      { label: "Experienced QA Questions", to: "/qa-interview-questions-experienced" },
    ],
  },
  {
    group: "Testing Types",
    items: [
      { label: "Acceptance Testing", to: "/acceptance-testing" },
      { label: "Functional Testing", to: "/functional-testing-guide" },
      { label: "Integration Testing", to: "/integration-testing" },
      { label: "Regression Testing", to: "/regression-testing" },
      { label: "Smoke Testing", to: "/what-is-smoke-testing" },
      { label: "Sanity Testing", to: "/what-is-sanity" },
      { label: "Performance Testing", to: routePaths.performanceTesting },
      { label: "Exploratory Testing", to: "/what-is-exploratory-testing" },
    ],
  },
  {
    group: "Techniques",
    items: [
      { label: "Black Box Testing", to: "/black-box-testing" },
      { label: "White Box Testing", to: "/white-box-testing" },
      { label: "Gray Box Testing", to: "/what-is-gray-box-testing" },
      { label: "Black vs White vs Gray Box", to: "/black-vs-white-vs-gray-box-testing" },
      { label: "White Box vs Black Box", to: "/what-is-white-box-and-black-box-testing" },
      { label: "Testing Pyramid", to: "/testing-pyramid" },
      { label: "Test Coverage", to: "/what-is-test-caverage" },
    ],
  },
  {
    group: "Process and Templates",
    items: [
      { label: "SDLC", to: routePaths.sdlc },
      { label: "Testing Types", to: routePaths.testingTypes },
      { label: "Testing Methods", to: routePaths.testingMethods },
      { label: "Testing Tools", to: routePaths.testingTools },
      { label: "Testing Practices", to: "/testing-practices" },
      { label: "Test Plan Template", to: routePaths.testPlanTemplate },
      { label: "Test Environment", to: routePaths.testEnvironment },
      { label: "Test Cases vs Test Suites", to: "/test-cases-vs-test-suites-understanding-vs-difference" },
      { label: "Create Issue Best Practices", to: "/create-issue" },
    ],
  },
  {
    group: "Automation and API",
    items: [
      { label: "Automation Practice Lab", to: routePaths.automationTesting },
      { label: "Automation Testcase Library", to: routePaths.automationTestcases },
      { label: "Automation Testing Tutorial", to: "/automation-testing-tutorial" },
      { label: "Selenium Tutorial", to: "/selenium-tutorial" },
      { label: "Selenium Interview Questions", to: "/selenium-interview-questions" },
      { label: "XPath Tutorial", to: "/xpath-tutorial" },
      { label: "Test Automation Framework", to: "/test-automation-framework" },
      { label: "Automation Testing Tools", to: "/automation-testing-tools" },
      { label: "Regression Testing Tools", to: "/top-regression-testing-tools" },
      { label: "Playwright Tutorial", to: "/playwright-tutorial" },
      { label: "Cypress Tutorial", to: "/cypress-tutorial" },
      { label: "Automation ROI", to: "/test-automation-roi" },
      { label: "Automation vs Manual Testing", to: "/automation-vs-manual-testing" },
      { label: "Manual vs Automation", to: "/manual-vs-automation-testing" },
      { label: "Top Automation Tools", to: "/test-automation-tools" },
      { label: "API Cheat Sheet", to: routePaths.apiCheatSheet },
      { label: "API Testing Examples", to: "/api-testing-examples" },
      { label: "SOAP vs REST API", to: "/soap-vs-rest-api" },
      { label: "API Testing Tools", to: "/api-testing-tools" },
      { label: "API Interview Questions", to: routePaths.apiInterview },
    ],
  },
];

export const searchCatalog = [
  {
    label: "Automation Testing",
    to: routePaths.automationTesting,
    category: "Topics",
    description: "Hands-on practice for Selenium-style UI automation.",
    keywords: ["automation", "selenium", "playwright", "widgets", "practice"],
    popular: true,
  },
  {
    label: "Automation Testcase Library",
    to: routePaths.automationTestcases,
    category: "Practice",
    description: "Scenario-driven automation testcase bank with execution steps, assertions, and framework thinking.",
    keywords: ["automation testcase", "automation scenarios", "selenium testcase", "playwright testcase", "ecommerce automation"],
    popular: true,
  },
  {
    label: "Automation Testing Tutorial",
    to: "/automation-testing-tutorial",
    category: "Topics",
    description: "Step-by-step automation testing tutorial for beginners.",
    keywords: ["automation testing tutorial", "automation beginner", "qa automation"],
    popular: true,
  },
  {
    label: "Selenium Tutorial",
    to: "/selenium-tutorial",
    category: "Topics",
    description: "Learn Selenium WebDriver, locators, waits, and browser automation.",
    keywords: ["selenium tutorial", "webdriver", "selenium beginner", "automation"],
    popular: true,
  },
  {
    label: "Selenium Interview Questions",
    to: "/selenium-interview-questions",
    category: "Interview Questions",
    description: "Selenium questions for WebDriver, waits, locators, and frameworks.",
    keywords: ["selenium interview questions", "webdriver interview", "automation interview"],
    popular: true,
  },
  {
    label: "XPath Tutorial",
    to: "/xpath-tutorial",
    category: "Tools",
    description: "Learn XPath locators for Selenium automation.",
    keywords: ["xpath tutorial", "selenium xpath", "dynamic xpath", "locators"],
    popular: true,
  },
  {
    label: "Test Automation Framework",
    to: "/test-automation-framework",
    category: "Topics",
    description: "Learn Page Object Model, data-driven testing, reporting, and CI/CD.",
    keywords: ["test automation framework", "page object model", "automation framework"],
  },
  {
    label: "Automation Testing Tools",
    to: "/automation-testing-tools",
    category: "Tools",
    description: "Compare Selenium, Playwright, Cypress, Appium, Postman, and Rest Assured.",
    keywords: ["automation testing tools", "selenium", "playwright", "cypress"],
  },
  {
    label: "Regression Testing Tools",
    to: "/top-regression-testing-tools",
    category: "Tools",
    description: "Compare Selenium, Playwright, Cypress, Katalon, and autonomous testing tools.",
    keywords: ["regression testing tools", "autonomous testing", "selenium", "playwright", "cypress"],
    popular: true,
  },
  {
    label: "Playwright Tutorial",
    to: "/playwright-tutorial",
    category: "Topics",
    description: "Learn Playwright locators, auto-waiting, tracing, and assertions.",
    keywords: ["playwright tutorial", "playwright automation", "auto waiting"],
  },
  {
    label: "Cypress Tutorial",
    to: "/cypress-tutorial",
    category: "Topics",
    description: "Learn Cypress commands, assertions, fixtures, and intercepts.",
    keywords: ["cypress tutorial", "cypress automation", "frontend testing"],
  },
  {
    label: "Automation vs Manual Testing",
    to: "/automation-vs-manual-testing",
    category: "Topics",
    description: "Compare automation testing and manual testing with real examples.",
    keywords: ["automation vs manual testing", "manual vs automation", "testing comparison"],
  },
  {
    label: "Manual Testing",
    to: routePaths.manualTesting,
    category: "Topics",
    description: "Core QA theory, STLC, defects, and test case basics.",
    keywords: ["manual", "stlc", "defect", "qa", "test case"],
    popular: true,
  },
  {
    label: "What is Manual Testing",
    to: "/what-is-manual-testing",
    category: "Topics",
    description: "Beginner-friendly manual testing definition, examples, benefits, and FAQs.",
    keywords: ["what is manual testing", "manual testing beginner", "manual testing tutorial"],
    popular: true,
  },
  {
    label: "Manual Testing Process",
    to: "/manual-testing-process",
    category: "Topics",
    description: "Step-by-step manual testing process from requirements to closure.",
    keywords: ["manual testing process", "testing process", "stlc"],
  },
  {
    label: "Manual Testing Examples",
    to: "/manual-testing-examples",
    category: "Topics",
    description: "Real-time manual testing examples for login, forms, ecommerce, and payments.",
    keywords: ["manual testing examples", "real time examples", "test scenarios"],
    popular: true,
  },
  {
    label: "Login Test Case Example",
    to: "/test-case-example-login",
    category: "Tools",
    description: "Step-by-step login page test case example with data, expected results, and bugs.",
    keywords: ["login test case", "test case example login", "login page testing"],
    popular: true,
  },
  {
    label: "Registration Test Case Example",
    to: "/test-case-example-registration",
    category: "Tools",
    description: "Registration page test case example with validation and duplicate user checks.",
    keywords: ["registration test case", "signup test cases", "form testing"],
  },
  {
    label: "Ecommerce Test Case Example",
    to: "/test-case-example-ecommerce",
    category: "Tools",
    description: "Ecommerce test cases for search, cart, coupon, checkout, and order confirmation.",
    keywords: ["ecommerce test cases", "cart test cases", "checkout testing"],
    popular: true,
  },
  {
    label: "Payment Test Case Example",
    to: "/test-case-example-payment",
    category: "Tools",
    description: "Payment testing examples for success, failure, timeout, duplicate charge, and refunds.",
    keywords: ["payment test cases", "payment gateway testing", "payment testing"],
  },
  {
    label: "Search Test Case Example",
    to: "/test-case-example-search",
    category: "Tools",
    description: "Search functionality test cases for exact, partial, no-result, filters, and sorting.",
    keywords: ["search test cases", "search functionality testing", "test case example search"],
  },
  {
    label: "Form Test Case Example",
    to: "/test-case-example-form",
    category: "Tools",
    description: "Form validation test cases for required fields, formats, dropdowns, and upload.",
    keywords: ["form test cases", "form validation testing", "test case example form"],
  },
  {
    label: "API Test Case Example",
    to: "/test-case-example-api",
    category: "Tools",
    description: "API test case example with method, endpoint, payload, status, body, and auth.",
    keywords: ["api test case example", "api testing examples", "api test cases"],
  },
  {
    label: "Bug Report Example",
    to: "/bug-report-example",
    category: "Tools",
    description: "Bug report example with steps, actual result, expected result, severity, and priority.",
    keywords: ["bug report example", "defect report example", "jira bug report"],
    popular: true,
  },
  {
    label: "Test Plan Example",
    to: "/test-plan-example",
    category: "Tools",
    description: "Practical test plan example with scope, strategy, environment, risks, and deliverables.",
    keywords: ["test plan example", "qa test plan", "test plan template"],
  },
  {
    label: "Real-Time Testing Scenarios",
    to: "/real-time-testing-scenarios",
    category: "Topics",
    description: "Real-time testing scenarios for login, ecommerce, payment, API, and releases.",
    keywords: ["real time testing scenarios", "qa scenarios", "testing practice examples"],
    popular: true,
  },
  {
    label: "Manual Testing Interview Questions",
    to: "/manual-testing-interview-questions",
    category: "Interview Questions",
    description: "Manual testing interview questions for freshers and beginners.",
    keywords: ["manual testing interview questions", "qa fresher interview", "testing interview"],
    popular: true,
  },
  {
    label: "API Testing",
    to: routePaths.apiTesting,
    category: "Topics",
    description: "Learn APIs, request validation, and response assertions.",
    keywords: ["api", "postman", "rest assured", "http", "request", "response"],
    popular: true,
  },
  {
    label: "API Testing Tutorial",
    to: "/api-testing-tutorial",
    category: "Topics",
    description: "Step-by-step API testing tutorial with HTTP, Postman, status codes, and examples.",
    keywords: ["api testing tutorial", "api testing beginner", "postman", "http methods"],
    popular: true,
  },
  {
    label: "Postman Tutorial",
    to: "/postman-tutorial",
    category: "Tools",
    description: "Learn Postman collections, environments, variables, auth, and tests.",
    keywords: ["postman tutorial", "postman api testing", "collections", "environment"],
    popular: true,
  },
  {
    label: "REST API Testing",
    to: "/rest-api-testing",
    category: "Topics",
    description: "Learn REST API testing with endpoints, methods, JSON, auth, and status codes.",
    keywords: ["rest api testing", "rest api", "json api", "api validation"],
    popular: true,
  },
  {
    label: "API Testing Interview Questions",
    to: "/api-testing-interview-questions",
    category: "Interview Questions",
    description: "API testing questions on Postman, status codes, authentication, and scenarios.",
    keywords: ["api testing interview questions", "api interview", "postman interview"],
    popular: true,
  },
  {
    label: "API Status Codes",
    to: "/api-status-codes",
    category: "Tools",
    description: "Learn HTTP status codes every API tester should know.",
    keywords: ["api status codes", "http status codes", "200", "401", "403", "500"],
    popular: true,
  },
  {
    label: "API Testing Examples",
    to: "/api-testing-examples",
    category: "Topics",
    description: "Real-time API testing examples for login, cart, search, orders, and payments.",
    keywords: ["api testing examples", "api scenarios", "api test cases"],
  },
  {
    label: "SOAP vs REST API",
    to: "/soap-vs-rest-api",
    category: "Topics",
    description: "Compare SOAP and REST API testing with examples.",
    keywords: ["soap vs rest api", "soap api testing", "rest api testing"],
  },
  {
    label: "API Testing Tools",
    to: "/api-testing-tools",
    category: "Tools",
    description: "Compare Postman, Rest Assured, SoapUI, Swagger, Newman, and JMeter.",
    keywords: ["api testing tools", "postman", "rest assured", "soapui", "swagger"],
  },
  {
    label: "API Test Cases",
    to: "/api-test-cases",
    category: "Topics",
    description: "Learn how to write API test cases for status, body, headers, auth, and schema.",
    keywords: ["api test cases", "api test case examples", "api testing checklist"],
  },
  {
    label: "Software Testing",
    to: routePaths.softwareTesting,
    category: "Topics",
    description: "A complete overview of testing concepts and QA foundations.",
    keywords: ["software testing", "overview", "guide", "testing types"],
  },
  {
    label: "Study Notes",
    to: routePaths.studyNotes,
    category: "Tools",
    description: "Quick notes, revision points, and cheat-sheet style content.",
    keywords: ["notes", "study", "cheat sheet", "reference"],
    popular: true,
  },
  {
    label: "API Testing Cheat Sheet",
    to: routePaths.apiCheatSheet,
    category: "Tools",
    description: "Fast revision sheet for real-world API testing basics.",
    keywords: ["api cheat sheet", "revision", "reference", "notes"],
  },
  {
    label: "Interview Questions",
    to: routePaths.interviewQuestions,
    category: "Interview Questions",
    description: "QA interview preparation across manual, API, and automation topics.",
    keywords: ["interview", "questions", "qa interview", "job prep"],
    popular: true,
  },
  {
    label: "QA Interview Questions Fresher",
    to: "/qa-interview-questions-fresher",
    category: "Interview Questions",
    description: "Freshers QA interview questions on manual testing, defects, SDLC, STLC, and examples.",
    keywords: ["qa interview questions fresher", "testing fresher interview", "manual testing fresher"],
    popular: true,
  },
  {
    label: "QA Interview Questions Experienced",
    to: "/qa-interview-questions-experienced",
    category: "Interview Questions",
    description: "Experienced QA interview questions on strategy, Agile, regression, metrics, and releases.",
    keywords: ["qa interview questions experienced", "senior qa interview", "test lead interview"],
    popular: true,
  },
  {
    label: "API Interview Questions",
    to: "/api-interview-questions",
    category: "Interview Questions",
    description: "API interview questions on REST, SOAP, status codes, Postman, auth, and schema validation.",
    keywords: ["api interview questions", "rest api interview", "postman interview"],
    popular: true,
  },
  {
    label: "Test Case Interview Questions",
    to: "/test-case-interview-questions",
    category: "Interview Questions",
    description: "Test case interview questions with login, search, payment, API, and review examples.",
    keywords: ["test case interview questions", "test case examples", "qa test design interview"],
  },
  {
    label: "HR Interview Questions QA",
    to: "/hr-interview-questions-qa",
    category: "Interview Questions",
    description: "HR round preparation for QA testers with self introduction and career questions.",
    keywords: ["hr interview questions qa", "qa hr round", "tester hr interview"],
  },
  {
    label: "Real-Time QA Interview Questions",
    to: "/real-time-interview-questions",
    category: "Interview Questions",
    description: "Project-based real-time QA interview questions for Agile, releases, defects, and APIs.",
    keywords: ["real time qa interview questions", "project based qa interview", "testing scenarios"],
    popular: true,
  },
  {
    label: "Top 100 QA Interview Questions",
    to: "/top-100-qa-interview-questions",
    category: "Interview Questions",
    description: "Top QA interview questions across manual, automation, Selenium, API, and HR.",
    keywords: ["top 100 qa interview questions", "qa interview questions", "software testing interview"],
    popular: true,
  },
  {
    label: "API Testing Interview",
    to: routePaths.apiInterview,
    category: "Interview Questions",
    description: "API-focused interview questions and practical preparation.",
    keywords: ["api interview", "rest interview", "backend testing"],
  },
  {
    label: "Enroll Courses",
    to: routePaths.enroll,
    category: "Courses",
    description: "Premium training, projects, mock interviews, and guided support.",
    keywords: ["course", "enroll", "premium", "demo class", "training"],
    popular: true,
  },
  {
    label: "Premium PDFs / eBooks",
    to: routePaths.premiumNotes,
    category: "Courses",
    description: "Paid QA PDF packs for JIRA, API testing, manual testing, Selenium, SQL, and interviews.",
    keywords: ["premium pdf", "ebooks", "qa notes", "paid notes", "jira pdf", "api testing pdf"],
    popular: true,
  },
  {
    label: "Product Catalog Demo",
    to: routePaths.product,
    category: "Practice",
    description: "A full ecommerce practice flow with storefront, search, cart, address, payment, invoice, success, and tracking.",
    keywords: ["product catalog", "storefront", "flash sales", "product details", "cart", "checkout", "invoice", "tracking"],
    popular: true,
  },
  {
    label: "Flash Sales",
    to: routePaths.flashSales,
    category: "Practice",
    description: "Discount-heavy product listing for product discovery and detail-page navigation.",
    keywords: ["flash sales", "discount products", "catalog", "demo store"],
  },
  {
    label: "Contact Us",
    to: routePaths.contact,
    category: "Courses",
    description: "Reach out for coaching, guidance, or support.",
    keywords: ["contact", "support", "message", "enquiry"],
  },
  {
    label: "Testing Blog",
    to: routePaths.testingBlog,
    category: "Blog",
    description: "Read practical posts and testing guides.",
    keywords: ["blog", "articles", "guides", "latest posts"],
    popular: true,
  },
  {
    label: "Top 50 Selenium Interview Questions",
    to: "/top-50-selenium-interview-questions",
    category: "Interview Questions",
    description: "High-traffic Selenium interview preparation guide for automation testers.",
    keywords: ["selenium interview questions", "webdriver", "automation interview"],
    popular: true,
  },
  {
    label: "Manual vs Automation Difference",
    to: "/difference-manual-vs-automation",
    category: "Blog",
    description: "Compare manual testing and automation testing with examples and career guidance.",
    keywords: ["manual vs automation", "difference manual automation testing", "qa blog"],
    popular: true,
  },
  {
    label: "Smoke vs Regression",
    to: "/smoke-vs-regression",
    category: "Blog",
    description: "Understand smoke testing vs regression testing with practical examples.",
    keywords: ["smoke vs regression", "smoke testing", "regression testing"],
    popular: true,
  },
  {
    label: "Black vs White Box Testing",
    to: "/black-vs-white-box-testing",
    category: "Blog",
    description: "Compare black box and white box testing with examples.",
    keywords: ["black box vs white box testing", "testing techniques"],
  },
  {
    label: "Test Plan Template Guide",
    to: "/test-plan-template-guide",
    category: "Blog",
    description: "Learn test plan template sections with a practical QA example.",
    keywords: ["test plan template guide", "test plan example", "qa documentation"],
  },
  {
    label: "QA Career Roadmap",
    to: "/qa-career-roadmap",
    category: "Blog",
    description: "QA roadmap for manual, API, automation, projects, resume, and interviews.",
    keywords: ["qa career roadmap", "qa roadmap", "software testing career"],
    popular: true,
  },
  {
    label: "Manual Testing Real Time Examples",
    to: "/manual-testing-real-time-examples",
    category: "Topics",
    description: "Practical manual testing examples for login, ecommerce, forms, and defects.",
    keywords: ["manual testing examples", "real time examples", "test cases"],
    popular: true,
  },
  {
    label: "QA Career Roadmap 2026",
    to: "/qa-career-roadmap-2026",
    category: "Courses",
    description: "Step-by-step roadmap for becoming a QA engineer in 2026.",
    keywords: ["qa roadmap", "qa career", "testing career", "2026"],
    popular: true,
  },
  {
    label: "Blog Archive",
    to: routePaths.blogArchive,
    category: "Blog",
    description: "Browse more QA-focused content and older posts.",
    keywords: ["archive", "blog archive", "posts"],
  },
  {
    label: "Admin Dashboard",
    to: routePaths.admin,
    category: "Dashboards",
    description: "Manage learners, training operations, and overview metrics.",
    keywords: ["admin", "dashboard", "management"],
  },
  {
    label: "Trainer Dashboard",
    to: routePaths.trainer,
    category: "Dashboards",
    description: "Track sessions, learners, and training progress.",
    keywords: ["trainer", "coach", "dashboard"],
  },
  {
    label: "Student Dashboard",
    to: routePaths.student,
    category: "Dashboards",
    description: "View your learning progress and account area.",
    keywords: ["student", "dashboard", "account"],
  },
  {
    label: "Login",
    to: routePaths.login,
    category: "Dashboards",
    description: "Sign in to your account and continue learning.",
    keywords: ["login", "signin", "auth", "account"],
  },
  {
    label: "Create Account",
    to: routePaths.signup,
    category: "Dashboards",
    description: "Create your learner account and start free learning.",
    keywords: ["signup", "register", "create account"],
  },
];

export const navGroups = [
  {
    id: "learn",
    label: "Learn",
    summary: "Free learning tracks and theory content",
    items: [
      { label: "Manual Testing", to: routePaths.manualTesting, hint: "Foundations and QA basics" },
      { label: "Automation Testing", to: "/automation-testing-tutorial", hint: "Practical automation learning" },
      { label: "API Testing", to: "/api-testing-tutorial", hint: "Requests, responses, and validation" },
      { label: "Software Testing", to: routePaths.softwareTesting, hint: "Complete testing overview" },
    ],
  },
  {
    id: "practice",
    label: "Practice",
    summary: "Hands-on exercises and free tools",
    items: [
      { label: "Automation Practice", to: routePaths.automationTesting, hint: "Interactive UI practice components" },
      { label: "Automation Testcases", to: routePaths.automationTestcases, hint: "Execution-ready scenario bank" },
      { label: "Ecommerce Demo Store", to: routePaths.product, hint: "Storefront, cart, payment, invoice, and tracking flow" },
      { label: "Study Notes", to: routePaths.studyNotes, hint: "Revision-friendly quick notes" },
      { label: "Premium PDFs / eBooks", to: routePaths.premiumNotes, hint: "Paid QA notes packs and digital products" },
      { label: "API Cheat Sheet", to: routePaths.apiCheatSheet, hint: "Fast API testing revision" },
    ],
  },
  {
    id: "courses",
    label: "Courses",
    summary: "Paid programs, demo booking, and mentorship",
    items: [
      { label: "Premium Course", to: routePaths.enroll, hint: "Projects, mock interviews, mentorship" },
      { label: "Paid PDF Store", to: routePaths.premiumNotes, hint: "Low-ticket QA eBooks and PDF packs" },
      { label: "Book Demo / Contact", to: routePaths.contact, hint: "Talk to us before enrolling" },
    ],
  },
  {
    id: "blog",
    label: "Blog",
    summary: "Articles, guides, and latest learning posts",
    items: [
      { label: "About QA Coder", to: routePaths.about, hint: "Mission, mentor, and learning approach" },
      { label: "Testing Blog", to: routePaths.testingBlog, hint: "Fresh learning content" },
      { label: "Blog Archive", to: routePaths.blogArchive, hint: "Browse older blog posts" },
      { label: "QA Career Roadmap", to: "/qa-career-roadmap", hint: "Career path for QA learners" },
    ],
  },
  {
    id: "interview-prep",
    label: "Interview Prep",
    summary: "Question banks and job-focused prep",
    items: [
      { label: "Interview Questions", to: routePaths.interviewQuestions, hint: "General QA interview prep" },
      { label: "QA Fresher Questions", to: "/qa-interview-questions-fresher", hint: "First QA job preparation" },
      { label: "Experienced QA Questions", to: "/qa-interview-questions-experienced", hint: "Scenario and ownership rounds" },
      { label: "Top 100 QA Questions", to: "/top-100-qa-interview-questions", hint: "Fast revision question bank" },
      { label: "API Testing Interview", to: routePaths.apiInterview, hint: "API-specific question bank" },
      { label: "HR Questions for QA", to: "/hr-interview-questions-qa", hint: "HR round preparation" },
    ],
  },
  {
    id: "dashboards",
    label: "Workspaces",
    summary: "Account, CRM, and QA workflow areas",
    items: [
      { label: "Student Dashboard", to: routePaths.student, hint: "Learner area" },
      { label: "Trainer Dashboard", to: routePaths.trainer, hint: "Trainer operations" },
      { label: "Admin Dashboard", to: routePaths.admin, hint: "Admin controls" },
      { label: "Bug Tracker", to: routePaths.bugs, hint: "Raise, assign, and track defects" },
    ],
  },
];

export const noResultRecommendations = [
  { label: "Start with Automation Testing", to: routePaths.automationTesting },
  { label: "Open Ecommerce Demo", to: routePaths.product },
  { label: "Review Study Notes", to: routePaths.studyNotes },
  { label: "Browse Premium PDFs", to: routePaths.premiumNotes },
  { label: "Prepare with Interview Questions", to: routePaths.interviewQuestions },
  { label: "Explore Premium Course", to: routePaths.enroll },
];

export const footerLinkGroups = [
  {
    title: "Quick Learning Links",
    links: [
      { label: "Software Testing Guide", to: routePaths.softwareTesting },
      { label: "Manual Testing", to: routePaths.manualTesting },
      { label: "What is Manual Testing", to: "/what-is-manual-testing" },
      { label: "Manual Testing Examples", to: "/manual-testing-examples" },
      { label: "Login Test Case Example", to: "/test-case-example-login" },
      { label: "Bug Report Example", to: "/bug-report-example" },
      { label: "Automation Testing", to: routePaths.automationTestingTopic },
      { label: "Automation Tutorial", to: "/automation-testing-tutorial" },
      { label: "Selenium Tutorial", to: "/selenium-tutorial" },
      { label: "XPath Tutorial", to: "/xpath-tutorial" },
      { label: "Regression Testing Tools", to: "/top-regression-testing-tools" },
      { label: "API Testing", to: routePaths.apiTesting },
      { label: "API Testing Tutorial", to: "/api-testing-tutorial" },
      { label: "Postman Tutorial", to: "/postman-tutorial" },
      { label: "API Status Codes", to: "/api-status-codes" },
      { label: "Study Notes", to: routePaths.studyNotes },
    ],
  },
  {
    title: "Top Categories",
    links: [
      { label: "Testing Types", to: routePaths.testingTypes },
      { label: "Testing Methods", to: routePaths.testingMethods },
      { label: "Testing Tools", to: routePaths.testingTools },
      { label: "SDLC", to: routePaths.sdlc },
      { label: "Performance Testing", to: routePaths.performanceTesting },
    ],
  },
  {
    title: "Courses and Practice",
    links: [
      { label: "Join Premium Course", to: routePaths.enroll },
      { label: "Premium PDFs / eBooks", to: routePaths.premiumNotes },
      { label: "Book Free Demo", to: routePaths.contact },
      { label: "Automation Practice", to: routePaths.automationTesting },
      { label: "Automation Testcases", to: routePaths.automationTestcases },
      { label: "Ecommerce Demo Store", to: routePaths.product },
      { label: "Flash Sales", to: routePaths.flashSales },
      { label: "Automation Framework", to: "/test-automation-framework" },
      { label: "Playwright Tutorial", to: "/playwright-tutorial" },
      { label: "Interview Questions", to: routePaths.interviewQuestions },
      { label: "API Interview Prep", to: routePaths.apiInterview },
      { label: "API Test Cases", to: "/api-test-cases" },
      { label: "Real-Time Scenarios", to: "/real-time-testing-scenarios" },
    ],
  },
  {
    title: "Student Resources",
    links: [
      { label: "About QA Coder", to: routePaths.about },
      { label: "Testing Blog", to: routePaths.testingBlog },
      { label: "Blog Archive", to: routePaths.blogArchive },
      { label: "QA Career Roadmap", to: "/qa-career-roadmap" },
      { label: "Test Plan Template Guide", to: "/test-plan-template-guide" },
      { label: "API Cheat Sheet", to: routePaths.apiCheatSheet },
      { label: "Selenium Interview Questions", to: "/selenium-interview-questions" },
      { label: "Top 50 Selenium Questions", to: "/top-50-selenium-interview-questions" },
      { label: "Top 100 QA Questions", to: "/top-100-qa-interview-questions" },
      { label: "QA Fresher Questions", to: "/qa-interview-questions-fresher" },
      { label: "QA Career Roadmap 2026", to: "/qa-career-roadmap-2026" },
      { label: "Test Plan Template", to: routePaths.testPlanTemplate },
      { label: "Test Environment", to: routePaths.testEnvironment },
    ],
  },
];

export const policyLinks = [
  { label: "Privacy Policy", to: routePaths.privacyPolicy },
  { label: "Terms and Conditions", to: routePaths.terms },
  { label: "Refund Policy", to: routePaths.refundPolicy },
  { label: "Sitemap", to: routePaths.home },
];
